<div class="card">
    <div class="cardContent">
        <div class="grid-container">
            @let anyRowsValue = anyRows();
            @if (!anyRowsValue) {
                <div class="no-rows-overlay">
                    <div class="subtitle">{{ 'grid.noRowsNoAdd' | translate }}</div>
                </div>
            } @else {
                <ag-grid-angular
                    class="ag-theme-alpine grid channelStatusMonitoringGrid"
                    [gridOptions]="gridOptions"
                    [rowData]="rowData"
                    [columnDefs]="columnDefs"
                    [statusBar]="statusBar"
                    [enableCellTextSelection]="true"
                    [ngClass]="{ hidden: !anyRowsValue }"
                    (firstDataRendered)="onFirstDataRendered($event)"
                    (sortChanged)="onSortChanged($event)"
                    (filterChanged)="onFilterChanged($event)"
                    (gridReady)="onGridReady($event)"
                >
                </ag-grid-angular>
            }
        </div>
    </div>
</div>
